import { atomWithStorage } from 'jotai/utils';

const adminAtom = atomWithStorage('adminMode', false);
adminAtom.debugLabel = 'Admin Mode';
export { adminAtom };
